import { Controller } from "@hotwired/stimulus"
import { runMcaptcha } from "../lib/mcaptcha"

// Adds honeypot/time-trap/mCaptcha protections to the Rails homepage contact form.
// Unlike portfolio (JSON API), this submits the form natively so Rails CSRF stays in place.

export default class extends Controller {
  static targets = ["form", "submitBtn", "tsField", "captchaContainer", "captchaCheck", "captchaLabel", "captchaToken", "error"]

  connect() {
    if (this.hasTsFieldTarget) {
      this.tsFieldTarget.value = String(Math.floor(Date.now() / 1000))
    }

    fetch('/portfolio/api/config')
      .then(r => r.json())
      .then(cfg => {
        this.mcaptchaCfg = cfg
        if (this.hasCaptchaContainerTarget && cfg.mcaptcha_sitekey) {
          this.initCaptchaUI()
        }
      })
      .catch(() => {})
  }

  initCaptchaUI() {
    this.captchaContainerTarget.innerHTML =
      '<div class="flex items-center gap-3 px-4 py-3 rounded border border-gray-300 bg-white">' +
        '<input type="checkbox" data-homepage-contact-target="captchaCheck" data-action="change->homepage-contact#solveCaptcha" class="w-5 h-5 cursor-pointer accent-orange-500">' +
        '<label data-homepage-contact-target="captchaLabel" class="cursor-pointer text-sm text-gray-700 m-0">Je ne suis pas un robot</label>' +
        '<input type="hidden" name="contact[mcaptcha__token]" data-homepage-contact-target="captchaToken">' +
      '</div>'
  }

  solveCaptcha() {
    if (!this.captchaCheckTarget.checked) return
    this.captchaCheckTarget.disabled = true
    this.captchaLabelTarget.textContent = 'Verification...'

    runMcaptcha(this.mcaptchaCfg)
      .then(token => {
        this.captchaTokenTarget.value = token
        this.captchaLabelTarget.textContent = 'Verifie ✓'
        this.captchaLabelTarget.classList.add('text-green-600')
      })
      .catch(() => {
        this.captchaLabelTarget.textContent = 'Erreur — reessayez'
        this.captchaLabelTarget.classList.add('text-red-600')
        this.captchaCheckTarget.checked = false
        this.captchaCheckTarget.disabled = false
      })
  }

  submit(event) {
    if (!this.hasCaptchaTokenTarget || !this.captchaTokenTarget.value) {
      event.preventDefault()
      if (this.hasErrorTarget) {
        this.errorTarget.style.display = 'block'
        this.errorTarget.textContent = 'Veuillez valider le captcha avant d\'envoyer.'
      }
    }
    // Otherwise let the form submit natively (Rails CSRF token included by form_with)
  }
}
